import { useEffect, useState } from "react";
import { getOdd } from "../../services/odd";
import useLoader from "../../hooks/useLoader";
import Header from "../../components/Header";
import OddList from "../../components/odd/OddList";
import Filter from "../../components/odd/Filter";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import Pagination from "../../components/common/Pagination";

const OddPage = () => {
  const [odd, setOdd] = useState([]);
  const { hideLoader, showLoader } = useLoader();
  const [pagination, setPagination] = useState({});
  const [activeFilters, setActiveFilters] = useState({ user_status: "1" });
  const [page, setPage] = useState(1);

  const fetchOdd = async (pageNo = 1, params = {}) => {
    try {
      showLoader();
      const res = await getOdd(pageNo, params);

      if (
        res?.status === 200 &&
        res?.data?.data?.records &&
        Array.isArray(res.data.data.records)
      ) {
        setOdd(res.data.data.records);
        setPagination(res.data?.data?.pagination || {});
      } else {
        setOdd([]);
        console.warn("Unexpected response format:", res);
      }
    } catch (error) {
      console.error("Error fetching odds:", error);
      setOdd([]);
    } finally {
      hideLoader();
    }
  };

  useEffect(() => {
    fetchOdd(page, activeFilters);
    // eslint-disable-next-line
  }, [page, activeFilters]);

  const filterOdd = (params = {}) => {
    setActiveFilters({ ...params });
    setPage(1);
  };

  const handleExport = async (exportParams = {}) => {
    try {
      showLoader();
      const response = await getOdd(1, exportParams);
      const blob = response.data;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "odd.xlsx";
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log("error while exporting odd", error);
    } finally {
      hideLoader();
    }
  };

  const addButton = {
    allowedRoles: ["employee"],
    link: "/odd/apply",
    text: "New Request",
    icon: <AddBoxOutlinedIcon fontSize="small" />,
  };

  return (
    <div>
      <Header title="ODD" addButton={addButton} />
      <Filter onFilter={filterOdd} exportOdd={handleExport} />
      <OddList
        oddData={odd}
        onFilter={filterOdd}
        activeFilters={activeFilters}
      />
      {pagination && odd.length > 0 && (
        <Pagination
          totalPages={pagination.totalPages}
          currentPage={Number(pagination.pageNo)}
          perPage={Number(pagination.perPage)}
          totalRecords={pagination.totalRecords}
          onPageChange={setPage}
        />
      )}
    </div>
  );
};

export default OddPage;
